import { AccommodationTileModel } from '@app/models/elastic-search';
import { ApiServiceBase } from '@app/services/abstracts/api-service.base';

export class ApiListingService extends ApiServiceBase {
    private static _instance: ApiListingService;

    public static get instance(): ApiListingService {
        if (!this._instance) {
            this._instance = new ApiListingService();
        }

        return this._instance;
    }

    public async getListingItem(accommodationId: string): Promise<AccommodationTileModel> {
        return await this.query<AccommodationTileModel>('listing', {
            accommodationId,
        });
    }
}
